import {Controller} from "@hotwired/stimulus"

// Persist the sidebar filter DOM ONLY across the Turbo visit its own form submit
// triggers (Apply / month click). data-turbo-permanent matches `#id[data-turbo-permanent]`
// on BOTH the live page and the incoming snapshot, so the server always renders the
// attribute; we strip it on connect and re-add it just before the form navigates.
// Without this, any later navigation to the page (fresh URL, no filter params) would
// transplant the old checked-up sidebar and filters would look applied when they aren't.
export default class extends Controller {
  connect() {
    this.element.removeAttribute("data-turbo-permanent")
    this.form = this.element.closest("form")
    this.arm = () => this.element.setAttribute("data-turbo-permanent", "")
    this.form?.addEventListener("submit", this.arm)
  }

  disconnect() {
    this.form?.removeEventListener("submit", this.arm)
  }
}
